import { useFormat } from 'vivat';

const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    date: {
      name: 'วันที่เติมน้ำมัน',
      width: '10rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDate(),
    },
    amount: {
      name: 'ปริมาณน้ำมัน (ลิตร)',
      width: '1fr',
      class: 'text-right',
      filter: (val: string) => toCurrency(val),
    },
    // uniqueId: {
    //   name: 'เลข DN',
    //   width: '1fr',
    //   class: 'text-center',
    //   // eslint-disable-next-line
    //   filter: (val: any, row: any) => row.item.deliveryNote?.uniqueId ? row.item.deliveryNote?.uniqueId : '',
    // },
    license: {
      name: 'ทะเบียนรถ',
      width: '12rem',
      class: 'text-right',
      // eslint-disable-next-line
      filter: (val: any, row: any) => row.item.vehicle?.license ? row.item.vehicle?.license : '',
    },
  },
  sortable: [
  ],
};
